export const prepareUrl = (url: string): string => {
  return url.replaceAll("(", "\\(").replaceAll(")", "\\)").replaceAll(" ", "");
};
